import styled from 'styled-components'

export const NameContainer = styled.div`
    flex-direction: row;
    display: flex;
`